<template>
  <el-drawer
    title="DETALLE DE VENTAS POR VENDEDOR"
    :visible.sync="drawer"
    size="80%"
    :before-close="handleBeforeClose"
  >
    <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
      <el-row style="padding: 20px">
        <table style="font-size: 25px" id="table-card">
          <tr style="font-size: 25px">
            <td>Vendedor:</td>
            <td>
              <strong> {{ SellerName }}</strong>
            </td>
          </tr>
        </table>
      </el-row>
    </el-col>

    <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
      <el-row style="padding: 20px">
        <table style="font-size: 25px" id="table-card">
          <tr>
            <td>
              <strong> {{ month }}</strong>
            </td>
          </tr>
        </table>
      </el-row>
    </el-col>
    <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
      <el-row style="padding: 20px">
        <table style="font-size: 25px" id="table-card">
          <!-- <tr style="font-size:20px">
            <td>Meta del Mes:</td>
            <td>
              <strong> {{ formatMonto(metaMount) }}</strong>
            </td>
          </tr> -->
          <tr style="font-size: 20px">
            <td>Venta del Mes:</td>
            <td>
              <strong>{{ formatMonto(VentaMes) }}</strong>
            </td>
          </tr>
          <!-- <tr style="font-size:20px">
            <td>% del Mes:</td>
            <td>
              <el-tag :type="getTagType">{{ calcPercent }}</el-tag>
            </td>
          </tr> -->
          <!-- <tr>
            <td>% del Mes:</td>
            <td>
              <strong> {{ calcPercent }}</strong>
            </td>
          </tr> -->
        </table>
      </el-row>
    </el-col>
    <div>
      <div class="text-right">
        <p>
          :
          <span class="label label-danger" style="font-size: 22px">
            <template> </template>
          </span>
        </p>
      </div>

      <el-row style="padding: 20px">
        <RabbeyTable3
          ref="table"
          v-loading="loadingDetails"
          :columns="columnsDetails"
          :summary-method="getSummariesKPI"
          :data="registeredSales"
          :height="560"
        />
      </el-row>
    </div>
  </el-drawer>
</template>

<script>
import {
  formatMonto,
  FormatPercentSalesKpi,
  GetMonthInLetterBeginingOnZero
} from "@/utils";
//import HyperlinkKpiSales from "@/components/functionals/HyperlinkKpiSales";
import { getSummariesKPI } from "@/helpers/TableRabbeyTools";
import { PaymentDetails } from "@/helpers/SalesReportColumns";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";

export default {
  name: "DetailReportSales",
  components: {
    RabbeyTable3
  },
  props: {
    year: Number
  },
  data() {
    return {
      metaMount: 0,
      registeredSales: [],
      drawer: false,
      month: "",
      SellerName: "",
      columnsDetails: [...PaymentDetails],
      loadingDetails: false
    };
  },
  computed: {
    MetaMes: function () {
      return this.items
        .filter((item) => item.SellerCode === this.currentSellerCode)
        .reduce(function (prev, item) {
          return item.MontlyTarget;
        }, 0);
    },
    /**
     * Optener la venta del mes del vendedor actual.
     */
    VentaMes: function () {
      if (this.registeredSales.length <= 0) {
        return 0;
      }

      return this.registeredSales
        .filter((item) => item.Amount > 0)
        .map((item) => item.Amount)
        .reduce((a, c) => a + c);
    },
    calcPercent() {
      if (this.metaMount <= 0) {
        return "0 %";
      }
      return formatMonto((this.VentaMes / this.metaMount) * 100);
    },
    //  percent: function() {
    //   return Math.round((this.TotalCumplida / this.Total) * 100);
    // },
    getTagType() {
      if (this.calcPercent <= 70) {
        return "danger";
      } else if (this.calcPercent >= 90) {
        return "success";
      } else if (this.calcPercent >= 71 && this.calcPercent <= 89) {
        return "warning";
      }
      return "info";
    }
  },

  methods: {
    FormatPercentSalesKpi,
    formatMonto,
    getSummariesKPI,
    show(row, month, typeDeal) {
      const monthT = GetMonthInLetterBeginingOnZero(month - 1);
      this.month = this.$t(`months.${monthT}`);
      this.SellerName = row.SellerName;
      this.metaMount = row.MontlyTarget;
      this.getDetailsinfo(row.SellerCode, month, this.year, typeDeal);
      this.drawer = true;
    },

    getDetailsinfo(code, month = Number, year = Number, typeDeal) {
      this.loadingDetails = true;
      const param = {
        SellerCode: code,
        Month: month,
        Year: year,
        CompanyId: this.currentCompany,
        TypeDeal: typeDeal
      };
      const api = `/api/SalesKpiApi/DetailsByMoths`;
      this.$http
        .get(api, { params: param })
        .then(({ data }) => {
          this.registeredSales = data.Items;
          this.loadingDetails = false;
        })
        .catch((error) => {
          this.$message.error("Error al consultar el detalle");
          console.error(error);
        })
        .finally(() => {
          this.loadingDetails = false;
        });
    },
    formatComments(comments) {
      return comments.split("•").join("<br/>");
    },
    handleBeforeClose(done) {
      done();
    }
  }
};
</script>

<style scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.golden {
  color: goldenrod;
}
</style>
